export default {"src":"/_next/static/media/glassdoor.b5e68d82.svg","height":24,"width":123,"blurWidth":0,"blurHeight":0};